import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능:상품 카테고리 검색을 위한 팝업
 * 세부설명:
 * 필수속성: Uid, CallBack:부모페이지 함수 호출, GoodsCategoryRef: 부모 페이지 에서 자식페이지 함수호출 위한 속성
 * 옵션속성: 
*/

export class GoodsCategory extends Component {
    static displayName = GoodsCategory.name;

    constructor(props) {
        super(props);
        this.state = {
            CategoryMan: [],
            CategoryMid: [],
            CategorySub: [],
            Man_Cd: "",
            Mid_Cd: "",
            Sub_Cd: ""
        };
        this.GoodsCategoryRef = React.createRef();
        this.handleCategoryMan_Click = this.handleCategoryMan_Click.bind(this);
        this.handleCategoryMid_Click = this.handleCategoryMid_Click.bind(this);
        this.handleCategorySub_Click = this.handleCategorySub_Click.bind(this);
        this.handleCategory_Click = this.handleCategory_Click.bind(this);
    }
    //초기화
    componentDidMount() {        
        this.CategoryDataCall();
    }
    //카테고리 저장소
    GoodsDataSetProp = {
        CategoryMid: [],
        CategorySub: []
    }
    async CategoryDataCall() {        
        try {
            let Data = await Big3Common.Get("api/Common/Common/GetCategory");
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataSet = JSON.parse(Data.multiDataTable);
                this.GoodsDataSetProp.CategoryMid = DataSet["categorymid"];
                this.GoodsDataSetProp.CategorySub = DataSet["categorysub"];
                //대분류 할당
                this.setState({
                    CategoryMan: DataSet["categoryman"],
                    CategoryMid: [],
                    CategorySub: [],
                    Man_Cd: "",
                    Mid_Cd: "",
                    Sub_Cd: ""
                });
            }
            else {
                console.log("등록된 카테고리가 없습니다.");
            }
        }
        catch (e) {
            console.log("CategoryDataCall: ", e)
        }
        return false;
    }
     
    //대분류 클릭
    handleCategoryMan_Click(ManCd) {
        let MidList = this.GoodsDataSetProp.CategoryMid.filter(list => list.man_cd === ManCd);
        //중분류 할당
        this.setState({ CategoryMid: MidList, CategorySub: [], Man_Cd: ManCd, Mid_Cd: "",Sub_Cd: ""});
        return false;
    }
    //중분류 클릭
    handleCategoryMid_Click(ManCd, MidCd) {
        let SubList = this.GoodsDataSetProp.CategorySub.filter(list => list.man_cd === ManCd && list.mid_cd === MidCd);
        //소분류 할당
        this.setState({ CategorySub: SubList, Mid_Cd: MidCd, Sub_Cd: ""});
        return false;
    }
    //소분류 클릭
    handleCategorySub_Click(SubCd) {
        this.setState({ Sub_Cd: SubCd});
        return false;
    }
    //부모창에 값전달 후 닫기
    handleCategory_Click(event) {
       
        if (this.props.CallBack !== undefined) {
            this.props.CallBack({
                Man_Cd: this.state.Man_Cd,
                Mid_Cd: this.state.Mid_Cd,
                Sub_Cd: this.state.Sub_Cd
            });
        }
        Big3Common.ModalClose(bootstrap, this.props.id);
        event.preventDefault();
    }
    CategoryManList() {
        let ListData = this.state.CategoryMan;
        let SelectManCd = this.state.Man_Cd;
        return (
            <div className="category_slectbox">
                <div className="title">대분류</div>
                <div className="select_box row row-cols-2 large_category">
                    {ListData.map(list =>
                        <div key={list.man_cd}
                            className={list.man_cd === SelectManCd ? "category_item col select" : "category_item col"}
                            onClick={() => { this.handleCategoryMan_Click(list.man_cd) }}>{list.man_nm}
                        </div>
                    )}
                </div>
            </div>
        );
    }
    CategoryMidList() {
        let ListData = this.state.CategoryMid;
        let SelectMidCd = this.state.Mid_Cd;
        return (
            <div className="category_slectbox">
                <div className="title">{ListData.length === 0 ? "" : "중분류"}</div>
                <div className="select_box row row-cols-3 middle_category">
                    {ListData.map(list =>
                        <div key={list.man_cd.concat(list.mid_cd)}
                            className={list.mid_cd === SelectMidCd ? "col select" : "col"}
                            onClick={() => { this.handleCategoryMid_Click(list.man_cd, list.mid_cd) }}>{list.mid_nm}
                        </div>
                    )}
                </div>
            </div>
        )
    }
    CategorySubList() {
        let ListData = this.state.CategorySub;
        let SelectSubCd = this.state.Sub_Cd;
        return (
            <div className="category_slectbox">
                <div className="title">{ListData.length === 0 ? "" : "소분류"}</div>
                <div className="select_box row row-cols-3 middle_category">
                    {ListData.map(list =>
                        <div key={list.man_cd.concat(list.mid_cd).concat(list.sub_cd)}
                            className={list.sub_cd === SelectSubCd ? "col select" : "col"}
                            onClick={() => { this.handleCategorySub_Click(list.sub_cd) }}>{list.sub_nm}
                        </div>
                    )}
                </div>
            </div>
        )
    }
    render() {
        let Depth1 = this.CategoryManList();
        let Depth2 = this.CategoryMidList();
        let Depth3 = this.CategorySubList();
        return (
            <div ref={this.GoodsCategoryRef} className="modal fade" tabIndex="-1" style={{ zIndex: this.props.zIndex === undefined ? 2000 : this.props.zIndex }} id={this.props.id} data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-dialog-centered ">
                    <div className="modal-content ordertype_modal">
                        <div className="modal-body text-center ">
                            <div className="desc ordertype_modal_in">
                                <div className="modal_title">카테고리</div>
                            </div>
                            {Depth1}
                            {Depth2}
                            {Depth3}  
                            <div className="ok_btn_box">
                                <button onClick={this.handleCategory_Click}>검색</button>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
